import Image from 'app/Components/Shared/Image/image';
import React, {useContext} from 'react';
import SimActivationContext from 'app/Components/Page/SimActivationPage/SimActivationContext';

function SimFailed() {
  const [{links}] = useContext(SimActivationContext);

  return (
    <div className='SimFailed'>
      <h1 className='SimActivationBlock__main__title' />
      <h1 className='SimActivationBlock__top__title'>אוקיי, זה לא היה צפוי... הניוד לא הושלם</h1>
      <p className='SimActivationBlock__top__link'>רוצה שניצור איתך קשר ממש בקרוב כדי להשלים את הפעלת הסים?</p>
      <div className='SimActivationBlock__image'>
        <Image src={require('../images/icons-error.svg')} />
      </div>

      <div className='SimActivationBlock__bottom__button'>
        <a href={links.endButtonUrl}>סיום</a>
      </div>
    </div>
  );
}

export default SimFailed;
